import { auth_route_group } from "./Authentication/routes";

export const root_route = [...auth_route_group];
